import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {useEffect, useState} from "react";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {CheckIcon, ThinArrowLeft, ThinTimeIcon, TomansIcon} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {PayTuitionModal} from "./pay-tuition";

interface tuitionInterface {
    id: number,
    price: number,
    paidAt: string,
    payMethod: "online" | "cash" | "old",
}

interface reminderInterface {
    id: number,
    price: number,
    date: string,
    isReminded: 0 | 1,
}

export const StudentsTuitionScreen = () => {
    const [data, setData] = useState({
        loaded: false,
        mode: 'dept' as 'dept' | 'upfront' | 'free',
        totalPrice: 0,
        reminders: [] as reminderInterface[],
        payments: [] as tuitionInterface[],
        tuitionPercentPaid: 0,
        tuitionPaidSoFar: 0,
        minPay:0,
        isTuitionSet:false,
        offAmount:0,
        extraProgramCost:0,
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/parents/tuition/overview',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                total: number,
                reminders: reminderInterface[] | null,
                payments: tuitionInterface[] | null,
                min:number,
                offAmount:number,
                extraProgramCost:number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                let paidSoFar = 0;
                let paidPercent = 0;
                if (d.payments !== null && d.total > 0) {
                    d.payments.forEach(t => {
                        paidSoFar += t.price;
                    });
                    paidPercent = (paidSoFar * 100) / d.total; // >0 makes sure DIVISION_BY_ZERO not happen
                }
                setData({
                    loaded: true,
                    payments: d.payments === null ? [] : d.payments,
                    reminders: d.reminders === null ? [] : d.reminders,
                    totalPrice: d.total,
                    tuitionPaidSoFar: paidSoFar,
                    tuitionPercentPaid: paidPercent,
                    minPay: d.min,
                    isTuitionSet: d.total !== -1,
                    mode: "dept",
                    offAmount: d.offAmount,
                    extraProgramCost: d.extraProgramCost,
                });
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "شهریه | نهال";
        fetchData();
    }, []);
    const [payModal, setPayModal] = useState({
        show: false,
        suggestedPrice: 0,
    });
    return (
        <>
            <BreadCrumbs links={[
                {title: 'پنل دانش‌آموزان', url: '/students/'},
                {title: 'شهریه', url: '/students/tuition'},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>وضعیت شهریه</b>
                                    </div>
                                    <div className="row justify-content-center align-items-center">
                                        <div className="col-lg-4">
                                            <div className="tuition-status">
                                                <span>نوع پرداخت</span>
                                                <b>{!data.isTuitionSet ? 'نامشخص' : (data.tuitionPercentPaid === 100 || data.totalPrice === 0 ? 'تکمیل شده' : 'بدهکار')}</b>
                                                <strong>{CurrencyFormat(data.tuitionPercentPaid.toFixed(0))}٪
                                                    پرداخت
                                                    شده</strong>
                                                <div className="progress">
                                                    <div
                                                        className="progress-bar progress-bar-striped progress-bar-animated"
                                                        style={{width: `${data.tuitionPercentPaid}%`}}/>
                                                </div>
                                                {data.extraProgramCost > 0 ? <em>دارای فوق برنامه ({CurrencyFormat(data.extraProgramCost)} تومان)</em> : null}
                                                {data.offAmount > 0 ? <em> {CurrencyFormat(data.offAmount)} تومان تخفیف اعمال شده است.</em> : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="tuition-status">
                                                <span>پرداخت شده</span>
                                                <p style={{color: 'darkgreen'}}>{CurrencyFormat(data.tuitionPaidSoFar)}
                                                    <TomansIcon/></p>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="tuition-status">
                                                <span>بدهکاری</span>
                                                <p style={{color: '#8b0000'}}>{!data.isTuitionSet ? '۰' : CurrencyFormat(data.totalPrice - data.tuitionPaidSoFar)}
                                                    <TomansIcon/></p>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        data.isTuitionSet ?
                                            <div className="d-flex justify-content-end align-items-center"
                                                 style={{gap: 10, marginTop: 20}}>
                                                <button className="btn-pay" onClick={() => setPayModal({
                                                    show: true,
                                                    suggestedPrice: 0,
                                                })}>
                                                    <b>پرداخت قسط</b>
                                                    <ThinArrowLeft/>
                                                </button>
                                            </div> : null
                                    }
                                    <hr/>
                                    <div className="screen-card-header">
                                        <b>لیست پرداخت‌های شهریه</b>
                                    </div>

                                    {
                                        data.payments.length > 0 ?
                                            <>
                                                <table
                                                    className="table open-table table-hover table-bordered">
                                                    <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>مبلغ</th>
                                                        <th>وضعیت</th>
                                                        <th>تاریخ پرداخت</th>
                                                        <th>نوع پرداخت</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        data.payments.map((t, i) =>
                                                            <tr key={"U23j82nD" + i}>
                                                                <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                                <td>
                                                                    <span>{CurrencyFormat(t.price)}<TomansIcon/></span>
                                                                </td>
                                                                <td><em><CheckIcon/>پرداخت شده</em></td>
                                                                <td>{StringDigitsConvertToPersian(GregorianToPersian(t.paidAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                                                                <td>{t.payMethod === 'old' ? 'سامانه قدیم' : (t.payMethod === 'cash' ? 'فیش' : 'آنلاین')}</td>
                                                            </tr>
                                                        )
                                                    }
                                                    </tbody>
                                                </table>
                                            </> : <div className="staff--not-found">
                                                <b>پرداختی یافت نشد</b>
                                                <p>هنوز پرداختی برای شهریه صورت نگرفته است.</p>
                                            </div>
                                    }
                                </div>
                            </div>
                            {
                                data.reminders.length > 0 ?
                                    <div className="col-lg-12">
                                        <div className="screen-card">
                                            <div className="screen-card-header">
                                                <b>یادآوری‌های شهریه</b>
                                            </div>
                                            <table className="table open-table table-bordered table-hover">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>تاریخ</th>
                                                    <th>مبلغ</th>
                                                    <th>وضعیت</th>
                                                    {data.isTuitionSet ? <th>امکانات</th> : null}
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    data.reminders.map((r, i) =>
                                                        <tr key={"k39Dj28D" + i}>
                                                            <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                            <td>{StringDigitsConvertToPersian(GregorianToPersian(r.date).replaceAll("-", "/"))}</td>
                                                            <td>
                                                                <span>{CurrencyFormat(r.price)}<TomansIcon/></span>
                                                            </td>
                                                            <td>
                                                                {
                                                                    r.isReminded === 1 ?
                                                                        <em>
                                                                            <CheckIcon/>
                                                                            اعلام شده
                                                                        </em> :
                                                                        <em data-color={"red"}>
                                                                            <ThinTimeIcon/>
                                                                            در انتظار
                                                                        </em>
                                                                }
                                                            </td>
                                                            {
                                                                data.isTuitionSet ?
                                                                    <td>
                                                                        <button className="btn-pay-tuition"
                                                                                data-text="yes"
                                                                                onClick={() => setPayModal({
                                                                                    show: true,
                                                                                    suggestedPrice: r.price,
                                                                                })}>
                                                                            پرداخت
                                                                            <ThinArrowLeft/>
                                                                        </button>
                                                                    </td> : null
                                                            }
                                                        </tr>
                                                    )
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div> : null
                            }
                        </div>
                    </div> : null
            }
            <PayTuitionModal
                active={payModal.show}
                closeHandler={() => setPayModal({
                    show: false,
                    suggestedPrice: 0,
                })}
                totalPrice={data.totalPrice}
                paidSoFar={data.tuitionPaidSoFar}
                suggestedPrice={payModal.suggestedPrice}
                min={data.minPay}
            />
        </>
    );
};